import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _57ab2ebe = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _19084e79 = () => interopDefault(import('../../../pages/carte.vue' /* webpackChunkName: "pages/carte" */))
const _04348cd6 = () => interopDefault(import('../../../pages/ContactToEtax.vue' /* webpackChunkName: "pages/ContactToEtax" */))
const _944ecc3a = () => interopDefault(import('../../../pages/etaxService.vue' /* webpackChunkName: "pages/etaxService" */))
const _e29c7c24 = () => interopDefault(import('../../../pages/index_old.vue' /* webpackChunkName: "pages/index_old" */))
const _18982e8e = () => interopDefault(import('../../../pages/inspire.vue' /* webpackChunkName: "pages/inspire" */))
const _6831c956 = () => interopDefault(import('../../../pages/po-kbank.vue' /* webpackChunkName: "pages/po-kbank" */))
const _178f5dd0 = () => interopDefault(import('../../../pages/purchaseOrderOthr.vue' /* webpackChunkName: "pages/purchaseOrderOthr" */))
const _06beb7ea = () => interopDefault(import('../../../pages/request_service_express.vue' /* webpackChunkName: "pages/request_service_express" */))
const _c97bbb50 = () => interopDefault(import('../../../pages/request-ttb.vue' /* webpackChunkName: "pages/request-ttb" */))
const _6042a77f = () => interopDefault(import('../../../pages/shareholder.vue' /* webpackChunkName: "pages/shareholder" */))
const _482400f4 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _08121016 = () => interopDefault(import('../../../pages/blog/_path/index.vue' /* webpackChunkName: "pages/blog/_path/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/blog",
    component: _57ab2ebe,
    name: "blog"
  }, {
    path: "/carte",
    component: _19084e79,
    name: "carte"
  }, {
    path: "/ContactToEtax",
    component: _04348cd6,
    name: "ContactToEtax"
  }, {
    path: "/etaxService",
    component: _944ecc3a,
    name: "etaxService"
  }, {
    path: "/index_old",
    component: _e29c7c24,
    name: "index_old"
  }, {
    path: "/inspire",
    component: _18982e8e,
    name: "inspire"
  }, {
    path: "/po-kbank",
    component: _6831c956,
    name: "po-kbank"
  }, {
    path: "/purchaseOrderOthr",
    component: _178f5dd0,
    name: "purchaseOrderOthr"
  }, {
    path: "/request_service_express",
    component: _06beb7ea,
    name: "request_service_express"
  }, {
    path: "/request-ttb",
    component: _c97bbb50,
    name: "request-ttb"
  }, {
    path: "/shareholder",
    component: _6042a77f,
    name: "shareholder"
  }, {
    path: "/",
    component: _482400f4,
    name: "index"
  }, {
    path: "/blog/:path",
    component: _08121016,
    name: "blog-path"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
